<div class="phone-container">
  <!-- @WARN use formly-field div wrapping, cause formly override provided css classes -->
  <div
    class="select"
    [ngClass]="{
      select_expanded: isDropdownOpened,
      select_focused: isSelectFocused || isDropdownOpened
    }"
  >
    <isp-select
      [options]="props.selectCountryProps.optionsUi$ | async"
      [formControl]="selectControl"
      [required]="props.required"
      [id]="'phone-select_' + id"
      [anchorTextFuncHTML]="props.selectCountryProps.anchorTextFuncHTML"
      [anchorTextFunc]="props.selectCountryProps.anchorTextFunc"
      [listWidth]="props.selectCountryProps.listWidth$ | async"
      [notFoundText]="props.selectCountryProps.notFoundText$ | async"
      [selectAllText]="props.selectCountryProps.selectAllText$ | async"
      [dropdownPopupClass]="'isp-dynamic-form-select-dropdown-popup'"
      [dropdownParentSelector]="
        props.selectCountryProps.dropdownParentSelector | formIdPrefix
      "
      [dropdownDirection]="props.selectCountryProps.dropdownDirection"
      [dropdownScrollSelector]="props.selectCountryProps.dropdownScrollSelector"
      (internalAction)="onInternalAction($event)"
      (blur)="setSelectFocused(false)"
      (focus)="setSelectFocused(true)"
    ></isp-select>
  </div>
  <div class="delimiter-input-container">
    <div class="delimiter" [class.delimiter_hidden]="isDropdownOpened"></div>
    <div class="isp-phone-input" [class.input_collapsed]="isDropdownOpened">
      <ispui-input [invalid]="showError">
        <input
          [maxlength]="props.maxLength"
          [required]="props.required"
          [formControl]="formControl"
          [formlyAttributes]="field"
          [type]="'text'"
          [name]="key"
          [id]="id"
          (input)="onInputChange($event)"
          (blur)="onInputBlur()"
          #inputElement
        />
      </ispui-input>
    </div>
  </div>
</div>
